import { Input, Component, OnInit } from '@angular/core';
import { ModalController, NavParams, NavController } from '../../../node_modules/@ionic/angular';

@Component({
  selector: 'app-view-text',
  templateUrl: './view-text.page.html',
  styleUrls: ['./view-text.page.scss'],
})
export class ViewTextPage implements OnInit {
  txt:any = '';
  constructor(
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public navCtrl: NavController,
  ) { 
    this.txt = navParams.get('txt');

    this.txt = this.txt.trim();
  }

  ngOnInit() { 
  }

  async dismiss(){
    await this.modalCtrl.dismiss();
  }

}
